import { localeStrings as strings } from 'applicationConfig';

export const transparencyGridColumns = [
  {
    cellTemplate: 'tradingVenueGroup',
    imgField: 'venueClass',
    field: 'tradingVenueGroupId',
    columnHeader: strings.transparencyGrid.businessHeader,
    width: '245px'
  },
  {
    field: 'name',
    columnHeader: strings.registerGrid.tradingVenueHeader,
    width: '290px'
  },
  {
    field: 'type',
    columnHeader: strings.transparencyGrid.typeHeader,
    width: '150px'
  },
  {
    field: 'mic',
    columnHeader: strings.transparencyGrid.micHeader,
    width: '215px',
    cellCss: 'center-text',
    headerCss: 'center-text'
  }
];

export const gridConfig = {
  isGroupView: true,
  groupField: 'tradingVenueGroupId'
};



// WEBPACK FOOTER //
// ./src/containers/Transparency/transparencyGridOptions.js